import React from "react";
import { NavLink } from "react-router-dom";
import {Translation as T} from "@awe-web/shared/lib";
import {useStartScreenPath} from "../user/store.js";
import logo from "./assets/logo.png";

import "./brand.scss";

const BRAND_TITLE_BMW = "FSD0000136";
const BRAND_TITLE_MINI = "FSD0000333";

export default function Brand() {
  const startScreenPath = useStartScreenPath();

  return (
    <div className="brand screen-header__brand">
      <NavLink className="brand__title" to={startScreenPath}>
        <T className="brand__title__row brand__title__row--bmw" code={BRAND_TITLE_BMW} />
        <T className="brand__title__row brand__title__row--mini" code={BRAND_TITLE_MINI} />
      </NavLink>
      <img className="brand__logo" src={logo} alt="" />
    </div>
  );
}
